module.exports = __webpack_public_path__ + "static/img/reg-banner.41b157da.jpg";